import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Snackbar as GenericSnackbar,
  tokens,
  useSingletonMobileMediaQuery,
} from "@sunrun/experience-ui-components";
import { Message } from "messages";

type SnackbarType = "success" | "error" | "warning" | "info";

const SNACKBAR_CONTENT_COLORS: Record<SnackbarType, string> = {
  success: tokens.SUCCESS_20,
  error: tokens.ERROR_20,
  warning: tokens.WARNING_20,
  info: tokens.INFO_20,
};

const Snackbar = () => {
  const navigate = useNavigate();
  const [isOpen, setOpen] = useState(false);
  const [toast, setToast] = useState<SnackbarPayload>();
  const isMobile = useSingletonMobileMediaQuery();

  const handler = (event: MessageEvent<Message | undefined>) => {
    const { data: message } = event;
    if (!message) return;

    switch (message.type) {
      case "COMMAND:SHOW_SNACKBAR":
        setOpen(true);
        setToast(message.payload);
        break;
      default:
        return message;
    }
  };

  useEffect(() => {
    window.addEventListener("message", handler);
    return () => {
      window.removeEventListener("message", handler);
    };
  }, []);

  const handleClose = () => {
    setOpen(false);
    setToast(undefined);
  };

  const snackbarAction = toast?.action ? (
    <Button
      size="xs"
      color="tertiary"
      style={{
        backgroundColor: SNACKBAR_CONTENT_COLORS[toast.type],
        color: tokens.WHITE,
      }}
      onClick={() => {
        const { url } = toast.action!;
        handleClose();
        navigate(url);
      }}
    >
      {toast.action.label}
    </Button>
  ) : undefined;

  return (
    <GenericSnackbar
      message={toast?.message ?? ""}
      open={isOpen}
      autoHideDuration={toast?.autoHideDuration}
      onClose={handleClose}
      type={toast?.type}
      posY={isMobile ? -96 : undefined}
      action={snackbarAction}
    />
  );
};

type SnackbarPayload = {
  type: SnackbarType;
  message: string;
  autoHideDuration?: number;
  action?: {
    label: string;
    url: string;
  };
};

export { Snackbar };
